import { render } from "./BasicExample.vue?vue&type=template&id=728e09e4"
import script from "./BasicExample.vue?vue&type=script&lang=ts"
export * from "./BasicExample.vue?vue&type=script&lang=ts"
script.render = render

export default script